module.exports = __webpack_public_path__ + "element-icons.ttf?b02bdc1b846fd65473922f5f62832108";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/style/element-theme/fonts/element-icons.ttf?t=1472440741
// module id = 252
// module chunks = 0